import { ApiErrorAlert } from "@/components/ui/ApiErrorAlert";
import { BoxLoader } from "@/components/ui/loaders";
import { useLogin } from "@/queries/auth";
import { Button, Stack, TextField, Typography } from "@mui/material";
import { useRef, useState } from "react";

export function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { mutate: login, error, isPending } = useLogin();

  const passwordInputRef = useRef<HTMLInputElement>(null);

  return (
    <Stack width={400} sx={{ m: "auto", mt: 15 }} gap={2}>
      <Typography variant="h6" component={"h2"} textAlign={"left"}>
        Hello, please log in
      </Typography>
      <TextField
        autoFocus
        label="Username"
        value={username}
        onChange={(e) => {
          setUsername(e.target.value);
        }}
        onKeyUp={(e) => {
          if (e.code === "Enter") {
            passwordInputRef.current?.focus();
          }
        }}
      />
      <TextField
        inputRef={passwordInputRef}
        label="Password"
        type="password"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
        }}
        onKeyUp={(e) => {
          if (e.code === "Enter") {
            login({ password, username });
          }
        }}
      />
      <Button
        variant="contained"
        onClick={() => {
          login({ password, username });
        }}
      >
        Log in
      </Button>
      <BoxLoader isLoading={isPending} />
      <ApiErrorAlert error={error} />
    </Stack>
  );
}
